import React, { useContext } from "react";
import { MediaAuthContext } from "../../../../store/context/media-auth-context";
import PropTypes from "prop-types";
import ARROW_ORANGE from "../../../../assets/images/vector/components/form/arrow_orange.svg";
import SVG_CHECK_MARK from "../../../../assets/images/vector/components/form/check_mark.svg";
import { getTrueClasses } from "../../../../helpers";
import RedirectButton from "./RedirectButton";
import Form from "./Form";
import "./index.scss";

const FormIntro = (props) => {
  const { redirectUrl, option, formOpacity, formCalculatedData } = props;
  const {
    auth: { isAuth },
  } = useContext(MediaAuthContext);
  return (
    <div
      className={getTrueClasses("PgESM-HI-FI", option?.customClass)}
      style={{ opacity: formOpacity }}
    >
      {isAuth ? (
        <RedirectButton path={redirectUrl} {...option.redirectButton} />
      ) : (
        <div className="PgESM-HI-FI-content">
          <Form {...formCalculatedData} {...option.form} />
          <div className="PgESM-HI-FI-agree">
            <span className="PgESM-HI-FI-agree__card">
              <img src={SVG_CHECK_MARK} alt="" />
              Sin tarjeta de crédito
            </span>
            <span className="PgESM-HI-FI-agree__text">
              Al ingresar tu email, aceptas recibir emails de marketing de
              AMZScout
            </span>
          </div>
          <img className="PgESM-HI-FI__arrow" src={ARROW_ORANGE} alt="" />
        </div>
      )}
    </div>
  );
};

FormIntro.propTypes = {
  option: PropTypes.object,
  redirectUrl: PropTypes.string,
  formCalculatedData: PropTypes.object,
};

export default FormIntro;
